import * as React from 'react';

import { PageTitleBar } from 'components';

const TagHeader = ({ children }: React.PropsWithChildren<unknown>) => (
  <PageTitleBar headerTitle={children} />
);

export { TagHeader };
